<template>
    <tabs class="tabs"
        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-4"
        tabContentClasses=""
        v-if="degree"
    >
        <tab-pane id="objectives" class="pb-5" v-if="canEdit || form.data.objectives">
            <span slot="title">{{ $t('logs.objectives') }}</span>
            <log-objectives v-model="form.data"
                :errors="form.errors"
                :loading="form.loading"
                :recording="form.recording"
                :simulation="simulation"
                :degree="degree"
            ></log-objectives>
        </tab-pane>

        <tab-pane id="control" class="pb-5" v-if="canEdit || form.data.scenario">
            <span slot="title">{{ $t('logs.scenario') }}</span>
            <log-scenario v-model="form.data"
                :errors="form.errors"
                :loading="form.loading"
                :recording="form.recording"
                :simulation="simulation"
                :degree="degree"
            ></log-scenario>
        </tab-pane>

        <tab-pane id="initial" class="pb-5" v-if="canEdit || !initialSituationEmpty">
            <span slot="title">{{ $t('logs.initial-situation') }}</span>
            <log-initial-situation v-model="form.data"
                :errors="form.errors"
                :loading="form.loading"
                :recording="form.recording"
                :simulation="simulation"
                :log="log"
                :degree="degree"
            ></log-initial-situation>
        </tab-pane>

        <tab-pane id="log" class="pb-5">
            <span slot="title">{{ $t('common.log') }}</span>
            <timeslots-crud :degree="degree" :lang="degree.lang" :log="log" :simulation="simulation"></timeslots-crud>
        </tab-pane>
    </tabs>
</template>

<script>
    import TimeslotsCrud from './TimeslotsCrud'
    import LogObjectives from './LogObjectives'
    import LogScenario from './LogScenario'
    import LogInitialSituation from './LogInitialSituation'

    export default {

        components: {
            TimeslotsCrud, LogObjectives, LogScenario, LogInitialSituation
        },

        props: {

            log: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            degree: {
                type: Object,
                required: true
            },

            form: {
                type: Object,
                required: true
            },
        },

        computed: {
            
            shared() {
                return this.degree.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.degree.owner_id
            },

            canEdit() {
                return !this.shared && this.degree.status != 'archived'
            },

            initialSituationEmpty() {
                const mainParamsEmpty = (this.log.flights || this.log.technical_means || this.log.current_situation
                        || this.log.zones || this.log.other) === null
                return this.initialParamsEmpty && mainParamsEmpty
            },

            initialParamsEmpty() {
                return (this.log.runways || this.log.qnh || this.log.atis || this.log.pilots_number) === null
            }
        },
    }
</script>
